/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import * as React from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import AssignmentForm, { IAssignment } from './AssignmentForm'
import { AssigneeType } from '../../types'
import { IFranchisees, ISites } from '../../models/Franchise'
import { IUserCapabilities } from '../../models/User'

export interface IReassignDialogState {
  assignment: IAssignment | null
}

export interface IReassignDialogProps {
  title: string
  isOpen: boolean
  defaultAssigneeType: AssigneeType
  franchiseesShown?: boolean
  franchiseeNameShownWithSite?: boolean
  capabilities: IUserCapabilities
  franchisees: IFranchisees
  sites: ISites
  onReassign: (assignment: IAssignment) => void
  onClose: () => void
}

export default class ReassignDialog extends React.Component<
  IReassignDialogProps,
  IReassignDialogState
> {
  constructor(props: any) {
    super(props)
    this.state = {
      assignment: null
    }
    this.onAssignmentChanged = this.onAssignmentChanged.bind(this)
    this.onReassign = this.onReassign.bind(this)
  }

  onAssignmentChanged(assignment: IAssignment) {
    this.setState({ assignment })
  }

  onReassign() {
    this.props.onReassign(this.state.assignment!)
  }

  render() {
    const franchiseesShown =
      typeof this.props.franchiseesShown == 'undefined'
        ? this.props.capabilities.myFranchisees
        : this.props.franchiseesShown

    return (
      <Dialog
        open={this.props.isOpen}
        onClose={this.props.onClose}
        fullWidth
        maxWidth='sm'
        PaperProps={{
          style: { overflow: 'visible' }
        }}
      >
        <DialogTitle>{this.props.title}</DialogTitle>
        <DialogContent style={{ overflow: 'visible' }}>
          <AssignmentForm
            entityAssignment='both'
            useAutocomplete={this.props.capabilities.useAutocomplete}
            franchiseesShown={franchiseesShown}
            franchiseeNameShownWithSite={this.props.franchiseeNameShownWithSite}
            franchisees={this.props.franchisees}
            sites={this.props.sites}
            assignee={this.props.defaultAssigneeType}
            assigneeId={-1}
            onAssignmentChanged={this.onAssignmentChanged}
            disableChangeType={true} // when reassign checklist/ticket/incident, you can't change entity type
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.onClose} color='primary'>
            Cancel
          </Button>
          <Button
            onClick={this.onReassign}
            disabled={
              !this.state.assignment || this.state.assignment.assigneeId == -1
            }
            color='primary'
          >
            Reassign
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}
